import {ILoaiLo} from '@entities/loai-lo/loai-lo.model';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {SERVER_API_URL} from '@app/app.constants';
import {HttpResponse, HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

interface Page {
  data: ILoaiLo[];
}

type EntityResponseType = HttpResponse<ILoaiLo>;
type EntityPageResponseType = HttpResponse<Page>;
type EntityArrayResponseType = HttpResponse<ILoaiLo[]>;
type EntityType = ILoaiLo;

@Injectable({
  providedIn: 'root',
})
export class LoaiLoService {
  private resourceUrl = SERVER_API_URL + 'api/tb-crop-types';
  private resourceUrlV2 = SERVER_API_URL + 'api/v2/tb-crop-types';
  constructor(private http: HttpClient) {}

  create(entity: EntityType): Observable<EntityResponseType> {
    const copy = this.toResourceEntity(entity);
    return this.http
      .post<EntityType>(this.resourceUrl, copy, {observe: 'response'})
      .pipe(map((res: EntityResponseType) => this.toEntity(res)));
  }

  update(entity: EntityType): Observable<EntityResponseType> {
    const copy = this.toResourceEntity(entity);
    return this.http
      .put<EntityType>(this.resourceUrl + '/' + entity.id, copy, {
        observe: 'response',
      })
      .pipe(map((res: EntityResponseType) => this.toEntity(res)));
  }

  query(req?: any): Observable<EntityArrayResponseType> {
    return this.http
      .get<EntityType[]>(`${this.resourceUrlV2}/NONG_NGHIEP`, {
        params: req,
        observe: 'response',
      })
      .pipe(map((res: EntityArrayResponseType) => this.toEntities(res)));
  }

  delete(id: string): Observable<EntityResponseType> {
    return this.http.delete(`${this.resourceUrl}/${id}`, {observe: 'response'});
  }

  find(id: string): Observable<EntityResponseType> {
    return this.http
      .get<EntityType>(`${this.resourceUrl}/${id}`, {observe: 'response'})
      .pipe(map((res: EntityResponseType) => this.toEntity(res)));
  }

  private toResourceEntity(entity: EntityType): EntityType {
    return entity;
  }

  private toEntity(res: EntityResponseType): EntityResponseType {
    return res;
  }

  private toEntities(res: EntityArrayResponseType): EntityArrayResponseType {
    if (res.body.length > 0) {
    }
    return res;
  }
}
